import { MaterialResources } from "@/state/MaterialResources";
import { MaterialSlot } from "./MaterialSlot";
import { Color } from "three";

export type MaterialSlotMappingItem = {
    materialName: string;
    color?: Color;
    ignoreTextureColor?: boolean;
    emissive?: Color;
    emissiveIntensity?: number;
};

export type MaterialSlotMapping = Record<string, MaterialSlotMappingItem>;

export const getDefaultMaterialSlotMapping = (
    materialSlots: Record<string, MaterialSlot>,
    materials: Record<string, MaterialResources>
): MaterialSlotMapping => {
    const result: MaterialSlotMapping = {};

    for (const [slotId, slot] of Object.entries(materialSlots)) {
        if (slot.type === "fixed") {
            if (slot.materialName) {
                result[slotId] = { materialName: slot.materialName };
            }
            continue;
        }

        // For selectable slots, find first suitable material
        const suitableMaterial = Object.values(materials).find(
            (material) =>
                slot.materialNames.includes(material.config.name) ||
                slot.groups.some((group) => material.config.groups.includes(group))
        );

        if (suitableMaterial) {
            result[slotId] = { materialName: suitableMaterial.config.name };
        }
    }

    return result;
};
